import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  ConfirmationType,
  Modules,
  NotificationDetails,
  NotificationHeader,
  NotificationTextMessage,
  RoutingPath,
} from '@app/core/Enum';
import { Notes } from '@app/core/Enum/note';
import {
  GetNoteParamModel,
  GlobalComponent,
  NoteDataModel,
} from '@app/core/Models';
import { CommonService } from '@app/core/Services';
import {
  CommonState,
  GetAllNote,
  GetNotesData,
  MenuState,
  SaveFundTransferData,
  SaveNoteData,
} from '@app/core/Store';
import { Select, Store } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject } from 'rxjs';
import { Note1Component } from '../note-1/note-1.component';
import { Note10Component } from '../note10/note10.component';
import { Note11Component } from '../note11/note11.component';
import { Note12Component } from '../note12/note12.component';
import { Note13Component } from '../note13/note13.component';
import { Note15Component } from '../note15/note15.component';
import { Note14Component } from '../note14/note14.component';
import { Note17Component } from '../note17/note17.component';
import { Note16Component } from '../note16/note16.component';
import { Note18Component } from '../note18/note18.component';
import { Note19Component } from '../note19/note19.component';
import { Note2Component } from '../note2/note2.component';
import { Note20Component } from '../note20/note20.component';
import { Note21Component } from '../note21/note21.component';
import { Note22Component } from '../note22/note22.component';
import { Note23Component } from '../note23/note23.component';
import { Note24Component } from '../note24/note24.component';
import { Note25Component } from '../note25/note25.component';
import { Note26Component } from '../note26/note26.component';
import { Note27Component } from '../note27/note27.component';
import { Note28Component } from '../note28/note28.component';
import { Note29Component } from '../note29/note29.component';
import { Note30Component } from '../note30/note30.component';
import { Note3Component } from '../note3/note3.component';
import { Note4Component } from '../note4/note4.component';
import { Note5Component } from '../note5/note5.component';
import { Note7Component } from '../note7/note7.component';
import { Note6Component } from '../note6/note6.component';
import { Note9Component } from '../note9/note9.component';
import { Note8Component } from '../note8/note8.component';
import { Note31Component } from '../note31/note31.component';
import { Note32Component } from '../note32/note32.component';
import { Note33Component } from '../note33/note33.component';
import { Note34Component } from '../note34/note34.component';
import { Note35Component } from '../note35/note35.component';
import { Note36Component } from '../note36/note36.component';
import { Note37Component } from '../note37/note37.component';
import { Note38Component } from '../note38/note38.component';
import { Note39Component } from '../note39/note39.component';
import { Note40Component } from '../note40/note40.component';
import { Note41Component } from '../note41/note41.component';
import { Note42Component } from '../note42/note42.component';
import { Note49Component } from '../note49/note49.component';
import { Note48Component } from '../note48/note48.component';
import { ConfirmationBoxComponent, Note43Component } from '@app/modules';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
})
export class NoteComponent implements OnInit {

  dataSource: any[] = [];
  tempDataSource: any[] = [];
  periodicDateList: any;

  headerText = 'Note 1';
  searchText = '';
  dataSourceSelectedLength = 0;

  notesModuleId = Notes.Note1;
  moduleId = Modules.Notes;
  thisperioicbuttonDisaply = false;

  ids: Array<any>;
  jsonObject: any;
  jsonObjectForCheckbox: any;
  jsonPercentageData: any;
  noteForm: FormGroup;
  displayedColumns: string[] = ['name'];

  @Select(CommonState.periodicDate)
  periodicDate$: Observable<Guid>;

  routingPath = RoutingPath;
  noteData: NoteDataModel;
  notesEnum = Notes;

  isAllSelected = false;

  notesId = Guid.EMPTY as unknown as Guid;
  periodicId = Guid.EMPTY as unknown as Guid;

  triggerSave: Subject<any> = new Subject<any>();

  triggerEditData: Subject<any> = new Subject<any>();

  @Select(MenuState.getSelectedMenuPermission)
  isViewPermission$: Observable<any>;
  commonNotificationText = NotificationTextMessage;

  @ViewChild(Note1Component, { static: false })
  note1Details;

  @ViewChild(Note2Component, { static: false })
  note2Details;

  @ViewChild(Note3Component, { static: false })
  note3Details;

  @ViewChild(Note4Component, { static: false })
  note4Details;

  @ViewChild(Note5Component, { static: false })
  note5Details;

  @ViewChild(Note6Component, { static: false })
  note6Details;

  @ViewChild(Note7Component, { static: false })
  note7Details;

  @ViewChild(Note8Component, { static: false })
  note8Details;

  @ViewChild(Note9Component, { static: false })
  note9Details;

  @ViewChild(Note10Component, { static: false })
  note10Details;

  @ViewChild(Note11Component, { static: false })
  note11Details;

  @ViewChild(Note12Component, { static: false })
  note12Details;

  @ViewChild(Note13Component, { static: false })
  note13Details;

  @ViewChild(Note14Component, { static: false })
  note14Details;

  @ViewChild(Note15Component, { static: false })
  note15Details;

  @ViewChild(Note16Component, { static: false })
  note16Details;

  @ViewChild(Note17Component, { static: false })
  note17Details;

  @ViewChild(Note18Component, { static: false })
  note18Details;

  @ViewChild(Note19Component, { static: false })
  note19Details;

  @ViewChild(Note20Component, { static: false })
  note20Details;

  @ViewChild(Note21Component, { static: false })
  note21Details;

  @ViewChild(Note22Component, { static: false })
  note22Details;

  @ViewChild(Note23Component, { static: false })
  note23Details;

  @ViewChild(Note24Component, { static: false })
  note24Details;

  @ViewChild(Note25Component, { static: false })
  note25Details;

  @ViewChild(Note26Component, { static: false })
  note26Details;

  @ViewChild(Note27Component, { static: false })
  note27Details;

  @ViewChild(Note28Component, { static: false })
  note28Details;

  @ViewChild(Note29Component, { static: false })
  note29Details;

  @ViewChild(Note30Component, { static: false })
  note30Details;

  @ViewChild(Note31Component, { static: false })
  note31Details;

  @ViewChild(Note32Component, { static: false })
  note32Details;

  @ViewChild(Note33Component, { static: false })
  note33Details;

  @ViewChild(Note34Component, { static: false })
  note34Details;

  @ViewChild(Note35Component, { static: false })
  note35Details;

  @ViewChild(Note36Component, { static: false })
  note36Details;

  @ViewChild(Note37Component, { static: false })
  note37Details;

  @ViewChild(Note38Component, { static: false })
  note38Details;

  @ViewChild(Note39Component, { static: false })
  note39Details;

  @ViewChild(Note40Component, { static: false })
  note40Details;

  @ViewChild(Note41Component, { static: false })
  note41Details;

  @ViewChild(Note42Component, { static: false })
  note42Details;

  @ViewChild(Note43Component, { static: false })
  note43Details;

  
  @ViewChild(Note48Component, { static: false })
  note48Details;

  @ViewChild(Note49Component, { static: false })
  note49Details;

  showSearchBar = false;
  shouldHideButton = false;
  @ViewChild('searchText') searchField: ElementRef;
  isChecked : boolean;
  constructor(
    private store: Store,
    public commonService: CommonService,
    private spinner: NgxSpinnerService,
    private globalComponent: GlobalComponent,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.setForm();
    this.bindSideList();
    this.setPeriodDate();
  }

  toggleSearchBar(): void {
    this.showSearchBar = !this.showSearchBar;

    if (this.showSearchBar) {
      setTimeout(() => {
        this.searchField.nativeElement.focus();
      }, 0);
    }
  }

  onSearch(): void {
    this.dataSource = [];
    this.tempDataSource.forEach((item) => {
      if (
        item.name
          .trim()
          .toLowerCase()
          .includes(this.searchText.trim().toLowerCase())
      ) {
        this.dataSource.push(item);
      }
    });
  }

  onSearchAll(): void {
    if (this.searchText === '') {
      this.onSearch();
    }
  }

  setPeriodDate(): void {
    this.periodicDateList = this.globalComponent.getFinancialPeriod();
    const defaultPeriodName = localStorage.getItem('defaultFinancialPeriod');
    if (defaultPeriodName) {
      const foundPeriod = this.periodicDateList.find(
        (p) => p.name.trim() === defaultPeriodName.trim()
      );
      if (foundPeriod) {
        this.noteForm.controls.accountingPeriod.setValue(foundPeriod.id);
      } else {
        this.noteForm.controls.accountingPeriod.setValue(
          this.periodicDateList[0].id
        );
      }
    } else {
      this.noteForm.controls.accountingPeriod.setValue(
        this.periodicDateList[0].id
      );
    }
    this.editNotes();
  }

  setForm(): void {
    this.noteForm = new FormGroup({
      accountingPeriod: new FormControl(''),
    });
  }

  bindSideList(): void {
    this.spinner.show();
    this.store.dispatch(new GetAllNote()).subscribe((res) => {
      this.spinner.hide();
      this.dataSource = res.note.noteSideList.filter(
        (i) =>
          i.id !== +Notes.Note44 &&
          i.id !== +Notes.Note45 &&
          i.id !== +Notes.Note46
      );

      this.tempDataSource = this.dataSource;
    });
  }

  noteClick(element: any): void {
    this.notesModuleId = element.id;
    this.getHeaderName();
    this.editNotes();
  }

  getHeaderName(): void {
    switch (this.notesModuleId) {
      case Notes.Note1:
        this.headerText = 'Accounting Policies';
        break;
      case Notes.Note2:
        this.headerText = 'Income from Donations and Legacies';
        break;
      case Notes.Note3:
        this.headerText = 'Income from Charitable Activities';
        break;
      case Notes.Note4:
        this.headerText = 'Income from Other Trading Activities';
        break;
      case Notes.Note5:
        this.headerText = 'Income from Investments';
        break;
      case Notes.Note6:
        this.headerText = 'Separate Material Item of Income';
        break;
      case Notes.Note7:
        this.headerText = 'Other Income';
        break;
      case Notes.Note8:
        this.headerText = 'Analysis of Receipts of Government Grants';
        break;
      case Notes.Note9:
        this.headerText = 'Donated Goods, Facilities and Services';
        break;
      case Notes.Note10:
        this.headerText = 'Expenditure on Raising Funds';
        break;
      case Notes.Note11:
        this.headerText = 'Expenditure on Charitable Activities';
        break;
      case Notes.Note12:
        this.headerText = 'Support Costs';
        break;
      case Notes.Note13:
        this.headerText = 'Finance Costs';
        break;
      case Notes.Note14:
        this.headerText = 'Governance Costs';
        break;
      case Notes.Note15:
        this.headerText = 'Separate Material Item of Expense';
        break;
      case Notes.Note16:
        this.headerText = 'Other Expenditure';
        break;
      case Notes.Note17:
        this.headerText = 'Extraordinary Items';
        break;
      case Notes.Note18:
        this.headerText = 'Funds Received as Agent';
        break;
      case Notes.Note19:
        this.headerText = 'Analysis of Support Costs';
        break;
      case Notes.Note20:
        this.headerText = 'Details of certain Items of Expenditure';
        break;
      case Notes.Note21:
        this.headerText = 'Employee’s Emoluments';
        break;
      case Notes.Note22:
        this.headerText = 'Defined contribution Pension Scheme';
        break;
      case Notes.Note23:
        this.headerText = 'Analysis of Grants Paid';
        break;
      case Notes.Note24:
        this.headerText = 'Intangible Fixed Assets';
        break;
      case Notes.Note25:
        this.headerText = 'Tangible Fixed Assets';
        break;
      case Notes.Note26:
        this.headerText = 'Heritage Assets';
        break;
      case Notes.Note27:
        this.headerText = 'Investments';
        break;
      case Notes.Note28:
        this.headerText = 'Stocks';
        break;
      case Notes.Note29:
        this.headerText = 'Debtors: Amounts falling due within one year';
        break;
      case Notes.Note30:
        this.headerText = 'Debtors: Amounts falling due after one year';
        break;
      case Notes.Note31:
        this.headerText = 'Creditors: Amounts falling due within one year';
        break;
      case Notes.Note32:
        this.headerText = 'Creditors: Amounts falling due after one year';
        break;
      case Notes.Note33:
        this.headerText = 'Deferred income';
        break;
      case Notes.Note34:
        this.headerText = 'Provisions for liabilities and charges';
        break;
      case Notes.Note35:
        this.headerText =
          'Other disclosures for debtors, creditors and other basic financial instruments';
        break;
      case Notes.Note36:
        this.headerText = 'Contingent liabilities and contingent assets';
        break;
      case Notes.Note37:
        this.headerText = 'Cash at bank and in hand';
        break;
      case Notes.Note38:
        this.headerText = 'Fair value of assets and liabilities';
        break;
      case Notes.Note39:
        this.headerText = 'Events after the end of the reporting period';
        break;
      case Notes.Note40:
        this.headerText = 'Charity funds';
        break;
      case Notes.Note41:
        this.headerText = 'Transactions with trustees and related parties';
        break;
      case Notes.Note42:
        this.headerText = 'Additional Disclosures';
        break;
      case Notes.Note43:
        this.headerText = 'Reference and Administrative Information';
        break;
      case Notes.Note48:
        this.headerText = 'Average No. of Employees';
        break;
      case Notes.Note49:
        this.headerText = 'General Information';
        break;
    }
  }

  setNotes1Data(): void {
    const textObj: any = {};
    const checkObj: any = {};

    // Generate textbox1 → textbox36 dynamically
    for (let i = 1; i <= 36; i++) {
      textObj[`textbox${i}`] = this.note1Details.note1Form.controls[`textbox${i}`].value;
      checkObj[`checkbox${i}`] = this.note1Details.note1Form.controls[`checkbox${i}`].value ? 1 : 0;
    }

    this.jsonObject = <JSON>textObj;
    this.jsonObjectForCheckbox = <JSON>checkObj;
  }

  setNotes2Data(): void {
    const arrayObj: any = {
      textbox1: this.note2Details.note2Form.controls.textbox1.value,
    };

    this.jsonObject = <JSON>arrayObj;
  }

  setNotes3Data(): void {
    const arrayObj: any = {
      textbox1: this.note3Details.note3Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes4Data(): void {
    const arrayObj: any = {
      textbox1: this.note4Details.note4Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes5Data(): void {
    const arrayObj: any = {
      textbox1: this.note5Details.note5Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes6Data(): void {
    const arrayObj: any = {
      textbox1: this.note6Details.note6Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes7Data(): void {
    const arrayObj: any = {
      textbox1: this.note7Details.note7Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes8Data(): void {
    const arrayObj: any = {
      textbox1: this.note8Details.note8Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes9Data(): void {
    const arrayObj: any = {
      textbox1: this.note9Details.note9Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes10Data(): void {
    const arrayObj: any = {
      textbox1: this.note10Details.note10Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes11Data(): void {
    const arrayObj: any = {
      textbox1: this.note11Details.note11Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes12Data(): void {
    const arrayObj: any = {
      textbox1: this.note12Details.note12Form.controls.textbox1.value,
    };
    const percentageData: any = {
      supportCost: this.note12Details.calculativeData.supportCost.map((x) => ({
        id: x.id,
        groupId: x.groupId,
        typeId: x.typeId,
        charitableActivity: x.charitableActivity,
        raisingFund: x.raisingFund,
      })),
      governanceCost: this.note12Details.calculativeData.governanceCost.map(
        (x) => ({
          id: x.id,
          groupId: x.groupId,
          typeId: x.typeId,
          charitableActivity: x.charitableActivity,
          raisingFund: x.raisingFund,
        })
      ),
    };
    this.jsonObject = <JSON>arrayObj;
    this.jsonPercentageData = <JSON>percentageData;
  }

  setNotes13Data(): void {
    const arrayObj: any = {
      textbox1: this.note13Details.note13Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes14Data(): void {
    const arrayObj: any = {
      textbox1: this.note14Details.note14Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes15Data(): void {
    const arrayObj: any = {
      textbox1: this.note15Details.note15Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes16Data(): void {
    const arrayObj: any = {
      textbox1: this.note16Details.note16Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes17Data(): void {
    const arrayObj: any = {
      textbox1: this.note17Details.note17Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes18Data(): void {
    const arrayObj: any = {
      textbox1: this.note18Details.note18Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes19Data(): void {
    const arrayObj: any = {
      textbox1: this.note19Details.note19Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes20Data(): void {
    const arrayObj: any = {
      textbox1: this.note20Details.note20Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes21Data(): void {
    const arrayObj: any = {
      textbox1: this.note21Details.note21Form.controls.textbox1.value,
      textbox2: this.note21Details.note21Form.controls.textbox2.value,
      textbox3: this.note21Details.note21Form.controls.textbox3.value,
      textbox4: this.note21Details.note21Form.controls.textbox4.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes22Data(): void {
    const arrayObj: any = {
      textbox1: this.note22Details.note22Form.controls.textbox1.value,
      textbox2: this.note22Details.note22Form.controls.textbox2.value,
      textbox3: this.note22Details.note22Form.controls.textbox3.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  prepareDataForApi(content: string): string | null {
    const cleaned = content.replace(/<p[^>]*>(\s|<br\s*\/?>)*<\/p>/gi, '').trim();
    return cleaned ? content : null;
  }

  setNotes23Data(): void {
    let text = this.note23Details.note23Form.controls.textbox4.value;
    const arrayObj: any = {
      textbox1: this.prepareDataForApi(this.note23Details.note23Form.controls.textbox1.value),
      textbox2: this.prepareDataForApi(this.note23Details.note23Form.controls.textbox2.value),
      textbox3: this.prepareDataForApi(this.note23Details.note23Form.controls.textbox3.value),
      textbox4: this.prepareDataForApi(text.replace("<p>", "<p style='text-align: justify;'>")),
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes24Data(): void {
    const arrayObj: any = {
      textbox1: this.note24Details.note24Form.controls.textbox1.value,
      textbox2: this.note24Details.note24Form.controls.textbox2.value,
      textbox3: this.note24Details.note24Form.controls.textbox3.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes25Data(): void {
    const arrayObj: any = {
      textbox1: this.note25Details.note25Form.controls.textbox1.value,
      textbox2: this.note25Details.note25Form.controls.textbox2.value,
      textbox3: this.note25Details.note25Form.controls.textbox3.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes26Data(): void {
    const arrayObj: any = {
      textbox1: this.note26Details.note26Form.controls.textbox1.value,
      textbox2: this.note26Details.note26Form.controls.textbox2.value,
      textbox3: this.note26Details.note26Form.controls.textbox3.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes27Data(): void {
    const arrayObj: any = {
      textbox1: this.note27Details.note27Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes28Data(): void {
    const arrayObj: any = {
      textbox1: this.note28Details.note28Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes29Data(): void {
    const arrayObj: any = {
      textbox1: this.note29Details.note29Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes30Data(): void {
    const arrayObj: any = {
      textbox1: this.note30Details.note30Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes31Data(): void {
    const arrayObj: any = {
      textbox1: this.note31Details.note31Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes32Data(): void {
    const arrayObj: any = {
      textbox1: this.note32Details.note32Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes33Data(): void {
    const arrayObj: any = {
      textbox1: this.note33Details.note33Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes34Data(): void {
    const arrayObj: any = {
      textbox1: this.note34Details.note34Form.controls.textbox1.value,
      textbox2: this.note34Details.note34Form.controls.textbox2.value,
      textbox3: this.note34Details.note34Form.controls.textbox3.value,
      textbox4: this.note34Details.note34Form.controls.textbox4.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes35Data(): void {
    const arrayObj: any = {
      textbox1: this.note35Details.note35Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes36Data(): void {
    const arrayObj: any = {
      textbox1: this.note36Details.note36Form.controls.textbox1.value,
      textbox2: this.note36Details.note36Form.controls.textbox2.value,
      textbox3: this.note36Details.note36Form.controls.textbox3.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes37Data(): void {
    const arrayObj: any = {
      textbox1: this.note37Details.note37Form.controls.textbox1.value,
    };

    this.jsonObject = <JSON>arrayObj;
  }

  setNotes38Data(): void {
    const arrayObj: any = {
      textbox1: this.note38Details.note38Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes39Data(): void {
    const arrayObj: any = {
      textbox1: this.note39Details.note39Form.controls.textbox1.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes40Data(): void {
    const arrayObj: any = {
      textbox1: this.note40Details.note40Form.controls.textbox1.value,
      textbox2: this.note40Details.note40Form.controls.textbox2.value,
      textbox3: this.note40Details.note40Form.controls.textbox3.value,
      textbox4: this.note40Details.note40Form.controls.textbox4.value,
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes41Data(): void {
    const textbox1 = this.note41Details.note41Form.controls.textbox1.value;
    const textbox2 = this.note41Details.note41Form.controls.textbox2.value;
    const textbox3 = this.note41Details.note41Form.controls.textbox3.value;

    const arrayObj: any = {
      textbox1: this.normalizeEditorValue(textbox1),
      textbox2: this.normalizeEditorValue(textbox2),
      textbox3: this.normalizeEditorValue(textbox3),
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes42Data(): void {
    const arrayObj: any = {
      textbox1: this.commonService.sanitizeHtml(
        this.note42Details.note42Form.controls.textbox1.value
      ),
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes43Data(): void {
    const arrayObj: any = {
      textbox1: this.commonService.sanitizeHtml(
        this.note43Details.note43Form.controls.textbox1.value
      ),
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes48Data(): void {
    const arrayObj: any = {
      textbox1: this.commonService.sanitizeHtml(
        this.note48Details.note48Form.controls.textbox1.value
      ),
    };
    this.jsonObject = <JSON>arrayObj;
  }

  setNotes49Data(): void {
    const arrayObj: any = {
      textbox1: this.commonService.sanitizeHtml(
        this.note49Details.note49Form.controls.textbox1.value
      ),
    };
    this.jsonObject = <JSON>arrayObj;
    this.jsonObjectForCheckbox = {
      checkbox1: this.isChecked ? 1 : 0,
    };
  }

  dataSubmit(): boolean {
    this.spinner.show();

    try {
      switch (this.notesModuleId) {
        case Notes.Note1:
          this.setNotes1Data();
          break;
        case Notes.Note2:
          this.setNotes2Data();
          break;
        case Notes.Note3:
          this.setNotes3Data();
          break;
        case Notes.Note4:
          this.setNotes4Data();
          break;
        case Notes.Note5:
          this.setNotes5Data();
          break;
        case Notes.Note6:
          this.setNotes6Data();
          break;
        case Notes.Note7:
          this.setNotes7Data();
          break;
        case Notes.Note8:
          this.setNotes8Data();
          break;
        case Notes.Note9:
          this.setNotes9Data();
          break;
        case Notes.Note10:
          this.setNotes10Data();
          break;
        case Notes.Note11:
          this.setNotes11Data();
          break;
        case Notes.Note12:
          this.setNotes12Data();
          break;
        case Notes.Note13:
          this.setNotes13Data();
          break;
        case Notes.Note14:
          this.setNotes14Data();
          break;
        case Notes.Note15:
          this.setNotes15Data();
          break;
        case Notes.Note16:
          this.setNotes16Data();
          break;
        case Notes.Note17:
          this.setNotes17Data();
          break;
        case Notes.Note18:
          this.setNotes18Data();
          break;
        case Notes.Note19:
          this.setNotes19Data();
          break;
        case Notes.Note20:
          this.setNotes20Data();
          break;
        case Notes.Note21:
          this.setNotes21Data();
          break;
        case Notes.Note22:
          this.setNotes22Data();
          break;
        case Notes.Note23:
          this.setNotes23Data();
          break;
        case Notes.Note24:
          this.setNotes24Data();
          break;
        case Notes.Note25:
          this.setNotes25Data();
          break;
        case Notes.Note26:
          this.setNotes26Data();
          break;
        case Notes.Note27:
          this.setNotes27Data();
          break;
        case Notes.Note28:
          this.setNotes28Data();
          break;
        case Notes.Note29:
          this.setNotes29Data();
          break;
        case Notes.Note30:
          this.setNotes30Data();
          break;
        case Notes.Note31:
          this.setNotes31Data();
          break;
        case Notes.Note32:
          this.setNotes32Data();
          break;
        case Notes.Note33:
          this.setNotes33Data();
          break;
        // case Notes.Note34:
        //   this.setNotes34Data();
        //   break;
        case Notes.Note35:
          this.setNotes35Data();
          break;
        case Notes.Note36:
          this.setNotes36Data();
          break;
        case Notes.Note37:
          this.setNotes37Data();
          break;
        case Notes.Note38:
          this.setNotes38Data();
          break;
        case Notes.Note39:
          this.setNotes39Data();
          break;
        case Notes.Note40:
          this.setNotes40Data();
          break;
        case Notes.Note41:
          this.setNotes41Data();
          break;
        case Notes.Note42:
          this.setNotes42Data();
          break;
        case Notes.Note43:
          this.setNotes43Data();
          break;
        case Notes.Note48:
          this.setNotes48Data();
          break;
        case Notes.Note49:
          this.setNotes49Data();
          break;
      }

      this.noteData = {
        accountingPeriodId: this.noteForm.controls.accountingPeriod.value,
        noteId: this.notesModuleId,
        checkBoxData:
          this.jsonObjectForCheckbox === undefined
            ? {}
            : this.jsonObjectForCheckbox,
        data: this.jsonObject,
        percentageData:
          this.jsonPercentageData === undefined
            ? null
            : this.jsonPercentageData,
        id: this.notesId,
        isChecked : this.isChecked
      };
    } catch (error) {
      this.spinner.hide();
      this.commonService.onFailure(NotificationTextMessage.errorMessage);
      return false;
    }
    return true;
  }


  editNotes(isOnLoad: boolean = false): void {
    if (!this.note40Details) {
      this.note40Details = {}; 
    }
    this.note40Details.showInput1 = false;
    this.note40Details.showInput2 = false;
    this.note40Details.showInput3 = false;
    this.note40Details.showInput4 = false;
    this.note40Details.showInput5 = false;
    this.note40Details.showInput6 = false;
    let index = this.periodicDateList.findIndex(
      (x) => x.id === this.noteForm.controls.accountingPeriod.value
    );
    if (index !== 0) {
      this.thisperioicbuttonDisaply = true;
    } else {
      this.thisperioicbuttonDisaply = false;
    }

    this.spinner.show();
    this.getHeaderName();

    const param: GetNoteParamModel = {
      id: this.notesModuleId,
      accountingPeriodId: this.noteForm.controls.accountingPeriod.value,
      ids: this.ids ?? null,
    };

    this.store.dispatch(new GetNotesData(param)).subscribe((res) => {
      const userInputData = res?.note?.noteData?.userInputData;
      this.notesId =
        userInputData !== null && userInputData !== undefined
          ? userInputData.id
          : (Guid.EMPTY as unknown as Guid);

      const param = {
        response: res.note.noteData,
        noteId: this.notesModuleId,
      };
      this.isChecked =
        this.notesModuleId === Notes.Note49
          ? userInputData?.checkBoxData?.checkbox1 === 1
          : !!userInputData?.isChecked;
      this.triggerEditData.next(param);
    });
  }

  onCancel(): void {
    this.ngOnInit();
  }

  onSave(): void {
  const isNote40 = this.notesModuleId === this.notesEnum.Note40;

  // Only proceed if:
  // - It's not Note40
  // - Or it's Note40 and the note40 form is valid
  if (!isNote40 || (isNote40 && this.note40Details?.note40Form.valid)) {
    if (this.dataSubmit()) {
      this.store
        .dispatch(new SaveNoteData(this.noteData))
        .subscribe({
          next: (res) => {
            if (res !== undefined) {
              this.notesId = res.note.noteId;
              this.commonService.onSucess(NotificationTextMessage.successMessage);
            } else {
              this.commonService.onFailure(NotificationTextMessage.errorMessage);
            }
          },
          error: (err) => {
            this.commonService.onFailure(err.error?.Message);
          },
        });
    }
  }

  // Call second API only for valid Note40 form
  if (isNote40) {
    if (this.note40Details?.note40Form.valid) {
      const note40Form = this.note40Details.note40Form;

      const obj: any = {
        id: Guid.EMPTY as unknown as Guid,
        companyId: Guid.EMPTY as unknown as Guid,
        accountingPeriodId: this.noteForm.controls.accountingPeriod.value,

        cY_Amount1: parseFloat(note40Form.controls.thisYearAmount1.value),
        cY_Amount2: parseFloat(note40Form.controls.thisYearAmount2.value),
        cY_Amount3: parseFloat(note40Form.controls.thisYearAmount3.value),

        pY_Amount1: parseFloat(note40Form.controls.lastYearAmount1.value),
        pY_Amount2: parseFloat(note40Form.controls.lastYearAmount2.value),
        pY_Amount3: parseFloat(note40Form.controls.lastYearAmount3.value),

        isDeleted: false,
        createdBy: Guid.EMPTY as unknown as Guid,
        createdOn: new Date(),
        updatedBy: Guid.EMPTY as unknown as Guid,
        updatedOn: new Date(),
      };

      this.store
        .dispatch(new SaveFundTransferData(obj))
        .subscribe({
          next: (res) => {
            if (res !== undefined) {
              this.commonService.onSucess(NotificationTextMessage.successMessage);
            } else {
              this.commonService.onFailure(NotificationTextMessage.errorMessage);
            }

            this.note40Details.showInput1 = false;
            this.note40Details.showInput2 = false;
            this.note40Details.showInput3 = false;
            this.note40Details.showInput4 = false;
            this.note40Details.showInput5 = false;
            this.note40Details.showInput6 = false;
          },
          error: (err) => {
            this.commonService.onFailure(err.error?.Message);
          },
        });
    } else {
      this.commonService.onFailure(NotificationTextMessage.invalidAmount);
    }
  }
}



  isActive(element: any): boolean {
    return this.notesModuleId === element.id;
  }

  onCopyClick(): void {
    this.dialog
      .open(ConfirmationBoxComponent, {
        data: {
          id: this.notesModuleId,
          type: ConfirmationType.Copy,
          moduleId: Modules.Note1,
          headerText: NotificationHeader.copyConfirmation,
          detailText: NotificationDetails.copyDetail,
          accountingPeriod: this.noteForm.controls.accountingPeriod.value,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          const param = {
            response: res,
            noteId: this.notesModuleId,
          };

          this.triggerEditData.next(param);
        }
      });
  }

  onAccountPeriodChange(): void {
    this.spinner.show();
    const selectedPeriodId = this.noteForm.controls.accountingPeriod.value;
    const selectedPeriod = this.periodicDateList.find(p => p.id === selectedPeriodId);
    if (selectedPeriod) {
      localStorage.setItem('defaultFinancialPeriod', selectedPeriod.name.trim());
    }
    this.editNotes(true);
  }

  normalizeEditorValue(content: any): string {
    if (content === null || content === undefined) {
      return '';
    }

    const value = String(content);
    const cleaned = value
      .replace(/&nbsp;/gi, ' ')
      .replace(/<p[^>]*>(\s|<br\s*\/?>|&nbsp;)*<\/p>/gi, '')
      .replace(/<br\s*\/?>/gi, '')
      .replace(/\s+/g, ' ')
      .trim();

    return cleaned ? value : '';
  }
}
